import $http from '@Config/axios';

const prefix = 'compras';

export const ComprasPresenter = {
	fetchCompras: params => $http.get(`${prefix}/fetchCompras`, params),
	listaDeCompras: params => $http.get(`${prefix}/listaDeCompras`, params)
};
